import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class PaymentReminderErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {},
            errors: [
                {
                    'code': 'blank_payment_reminder_message_error',
                    'text': 'Payment reminder message cannot be blank'
                }
            ]
        }
    }

    static errorCodes() {
        return [
            'blank_payment_reminder_message_error',
            'customer_without_collections_email_error',
            'customer_without_overdue_invoices_error',
        ];
    }
}
